import React, { useContext, useEffect, useState } from "react";
import { HeaderHeading } from "../../../../Context";
import Wrapper from "../../../../components/common/Wrapper/Wrapper";
import service from "../../../../api/services";
import organisms from "../../../../components/organisms";
import { Default_Page_Limit, Default_Page_Number } from "../../../../constants/defaultValues";
import { useSearchParams } from "react-router-dom";
import { getParams } from "../../../../constants/utils";
import constant from "../../../../constants/constant";

const { LostBarcodeHistory } = organisms

const Index = () => {
    const [searchParams] = useSearchParams();
    const [typeValue, setTypeValue] = useState<any>(getParams('history-type') == constant.BRAND_CATEGORY[0]?.value)
    const [initialLoading, setInitialLoading] = useState<boolean>(false)
    const [markBarcode, setMarkBarcode] = useState<boolean>(false)
    const [search, setSearch] = useState("")
    const [pageParams, setPageParams] = useState({
        currentPage: Default_Page_Number,
        limitPerPage: Default_Page_Limit
    })
    const [lostBarcode, setLostBarcode] = useState<any>()
    const { setHeader, setSidebar }: any = useContext(HeaderHeading);

    useEffect(() => {
        let tempValue: any = getParams('history-type')
        setTypeValue(tempValue == constant.BRAND_CATEGORY[0]?.value)
        setPageParams({
            currentPage: Default_Page_Number,
            limitPerPage: Default_Page_Limit
        })
        setSearch('')
    }, [searchParams])

    const getLostBarcode = async () => {
        try {
            let response = await service.barcodeStatus.getLostBarcode({
                "page": pageParams?.currentPage, "search": search, "limit": pageParams?.limitPerPage,
                is_recognised: typeValue
            })
            if (response.status === 200) {
                setLostBarcode(response.data)
            }
        } catch (error: any) {
            console.log(error)
        }
    }

    const handleChangeParams = (name: string, value: number) => {
        setPageParams({ ...pageParams, [name]: value })
    }

    useEffect(() => {
        setHeader("Barcode - Lost History")
        getLostBarcode()
        setSidebar(false)
    }, [pageParams.currentPage])

    useEffect(() => {
        handleChangeParams("currentPage", 1)
        if (pageParams.currentPage == 1 && initialLoading) {
            getLostBarcode()
        }
        setInitialLoading(true)
    }, [pageParams.limitPerPage, search,typeValue])

    return (
        <Wrapper>
            <LostBarcodeHistory
                setSearch={(value: string) => setSearch(value)}
                lostBarcode={lostBarcode}
                currentPage={pageParams?.currentPage}
                setCurrentPage={(page: number) => handleChangeParams("currentPage", page)}
                setLimitPerPage={(limit: number) => handleChangeParams("limitPerPage", limit)}
                limit={pageParams?.limitPerPage}
                setMarkBarcode={(value: boolean) => setMarkBarcode(value)}
                markBarcode={markBarcode}
                typeValue={typeValue}
            />
        </Wrapper>
    )
}

export default Index